import { render, staticRenderFns } from "./AlertingRuleForm.vue?vue&type=template&id=c8b37a12&scoped=true"
import script from "./AlertingRuleForm.vue?vue&type=script&lang=js"
export * from "./AlertingRuleForm.vue?vue&type=script&lang=js"
import style0 from "./AlertingRuleForm.vue?vue&type=style&index=0&id=c8b37a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b37a12",
  null
  
)

export default component.exports